import { Panneau } from "../admin/ui.tsx";
import { EnCours } from "../screens/EnCours.tsx";
import { Badge, Docs, Planning, Rencontres, RoleDashboard } from "./parts.tsx";
import { Scan } from "./Scan.tsx";
import { Gamification } from "./Gamification.tsx";
import { TunnelForm, type TunnelKind } from "./tunnels.tsx";

/** Répartiteur des espaces privés (hors back-office) : tunnels, dashboards, parcours sur place. */
export function FrontRoute({ chemin }: { chemin: string }): React.ReactElement {
  if (chemin.startsWith("/inscription/")) {
    const kind = chemin.slice("/inscription/".length) as TunnelKind;
    return <TunnelForm kind={kind} />;
  }
  if (chemin.endsWith("/prospects")) return <Scan />;
  if (chemin.endsWith("/invites")) return <TunnelForm kind="invite" />;
  if (chemin.endsWith("/jeu") || chemin.endsWith("/gamification")) return <Gamification />;
  if (chemin.endsWith("/parcours")) return <div style={{ maxWidth: 720 }}><Rencontres /></div>;
  if (chemin.endsWith("/planning")) return <Planning />;
  if (chemin.endsWith("/documents")) return <div style={{ maxWidth: 720 }}><Docs /></div>;
  if (chemin.endsWith("/collaborateurs")) return <Collaborateurs />;
  if (chemin === "/visiteur") return <div style={{ maxWidth: 720, display: "flex", flexDirection: "column", gap: 20 }}><Badge /><Rencontres /></div>;

  // /stagiaire, /intervenant, /conferencier, /organisateur, /invite, /gestionnaire…
  if (/^\/[a-z_]+$/.test(chemin)) return <RoleDashboard />;
  return <EnCours />;
}

function Collaborateurs(): React.ReactElement {
  const membres = [
    ["Marie Rousseau", "Cheffe de projet", "marie.rousseau@delabie.fr"],
    ["Thomas Petit", "Commercial", "t.petit@delabie.fr"],
    ["Léa Fontaine", "Technicienne", "l.fontaine@delabie.fr"],
  ];
  return (
    <Panneau titre="Mes collaborateurs" sous="L'équipe présente sur le salon — chacun reçoit un accès et un badge.">
      <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
        {membres.map(([n, f, e]) => (
          <div key={e} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12, padding: "11px 13px", border: "1px solid var(--line)", borderRadius: 10 }}>
            <div>
              <div style={{ fontWeight: 600 }}>{n}</div>
              <div style={{ fontSize: 12.5, color: "var(--muted)" }}>{f} · {e}</div>
            </div>
            <button className="btn btn-ghost" style={{ padding: "5px 11px", fontSize: 12 }}>Retirer</button>
          </div>
        ))}
      </div>
      <button className="btn btn-primary" style={{ alignSelf: "flex-start" }}>Ajouter un collaborateur</button>
    </Panneau>
  );
}
